import { Component, Input, OnInit, OnDestroy, ViewEncapsulation, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { Subject, takeUntil } from 'rxjs';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { MenuType } from '../../../services/navigation/menu-type.types';
import { ZopNavigationItem, ZopBrandingService } from '@zopup/zop-ux-core';
import { ZopUxLayoutLibConfig } from '../../../services/config/config.types';


import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'zop-footer',
    templateUrl: './footer.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [CommonModule, RouterModule, MatIconModule, TranslocoModule],
})

export class FooterComponent implements OnInit, OnDestroy {
    @Input() config: ZopUxLayoutLibConfig;
    navigation: MenuType;
    footerNavigation: ZopNavigationItem[] = [];
    socialNavigation: ZopNavigationItem[] = [];
    readonly branding = inject(ZopBrandingService);

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _navigationService: NavigationService,
        private _domSanitizer: DomSanitizer
    ) { }

    get currentYear(): number {
        return new Date().getFullYear();
    }

    get copyrightText(): SafeHtml {
        return this._domSanitizer.bypassSecurityTrustHtml(this.config?.copyWriteText?.replace('{{currentYear}}', this.currentYear.toString()) || '');
    }

    ngOnInit(): void {
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: MenuType) => {
                this.navigation = navigation;
                // We use footer navigation items
                this.footerNavigation = navigation.footer || [];
                // We use social navigation items
                this.socialNavigation = navigation.social || [];
            });

    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
